import React from 'react';
import './App.css';
import Piano from './components/Piano';

function App() {
  return (
    <div className="App">
      <header className="App-header">

      
        <Piano />
      </header>
    </div>
  );
}

export default App;
